import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=68a235bb&"
import script from "./Report.vue?vue&type=script&lang=ts&"
export * from "./Report.vue?vue&type=script&lang=ts&"
import style0 from "./Report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports